import {ModelSetOptions} from 'backbone';

import * as navigation from 'Navigation';

interface AdcMapTabStateAttributes {
  adcId: string;
}

interface AdcMapTabState {
  get<K extends keyof AdcMapTabStateAttributes>(key: K): AdcMapTabStateAttributes[K];
  set<K extends keyof AdcMapTabStateAttributes>(
    attributeName: K,
    value: AdcMapTabStateAttributes[K],
    options?: ModelSetOptions
  ): AdcMapTabState;
  set(obj: Partial<AdcMapTabStateAttributes>): AdcMapTabStateAttributes;
}

class AdcMapTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'ADC Map',
      closeable: false,
      preferenceKey: 'adc-map',
    };
  }
}

export default AdcMapTabState;
